<template>
    <svg viewBox="0 0 24 24" height="24px" width="24px" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
        <g>
            <path d="m12 2a10 10 0 0 0 0 20 1 1 0 0 0 0-2 8 8 0 1 1 8-8 1 1 0 0 0 2 0 10 10 0 0 0 -10-10z"/>
            <path d="m12 6a1 1 0 0 0 -1 1v4.59l-2.71 2.7a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l3-3a1 1 0 0 0 .29-.71v-5a1 1 0 0 0 -1-1z"/>
            <path d="m18 17a1 1 0 0 0 -1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0 -1-1z"/>
            <circle cx="18" cy="15" r="1"/>
        </g>
    </svg>
</template>